import { DraftConfiguration, DraftState, SpecialFontTask } from '@/types';
import { isTemplateAdminMode } from '@/utils/params';
import { getBendingTextSize } from '@/utils/text/getBendingTextSize';
import { getTextSize } from '@/utils/text/getTextSize';
import { isMultiLine } from '@/utils/text/isMultiLine';
import { updateTextCoordinates } from '@/utils/text/updateTextCoordinates';
import {
  isDraftBendingTextConfiguration,
  isDraftConfigurationWithTextOrSpecialText,
  isDraftPlaceholderTextConfiguration,
  isDraftSpecialTextConfiguration,
  isDraftTextOrPlaceHolderTextConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { setSpecialFontTask } from '@/components/draft/draftState/actions/helper/setSpecialFontTask';
import { updatePlaceholderSize } from './helper/updatePlaceholderSize';
import { updateSizeAndOffset } from './helper/updateSizeAndOffset';

export const setTextAction =
  ({ cid }: DraftConfiguration, content: string, task?: SpecialFontTask) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftConfigurationWithTextOrSpecialText(configuration)) {
      const text = configuration.text;
      const textStyle = text.style;
      if (isMultiLine(content) && !isMultiLine(text.content)) {
        textStyle.textAlign = 'center';
      } else if (isMultiLine(text.content) && !isMultiLine(content)) {
        textStyle.textAlign = 'left';
      }
      text.content = content;

      if (isDraftTextOrPlaceHolderTextConfiguration(configuration)) {
        const text = configuration.text;
        updateTextCoordinates(text);
        updateSizeAndOffset(configuration, getTextSize(text));

        if (isDraftPlaceholderTextConfiguration(configuration) && isTemplateAdminMode()) {
          configuration.offset.x = configuration.placeholderCenter.x - configuration.size.width / 2;
          updatePlaceholderSize(configuration);
        }
      }

      if (isDraftBendingTextConfiguration(configuration)) {
        updateSizeAndOffset(configuration, getBendingTextSize(configuration.text));
      }

      if (task && isDraftSpecialTextConfiguration(configuration)) {
        setSpecialFontTask(configuration, task);
      }
    }
  };
